import React from "react";

import { COLORS } from "@tSurya/theme/design.mgbw";

const MGBWBackIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M13.8271 16.9229C13.9782 17.0739 13.9782 17.3011 13.8271 17.4521C13.6767 17.6026 13.4509 17.6032 13.2998 17.4541L6.23731 10.2666L6.23535 10.2646C6.10779 10.1371 6.08301 10.0606 6.08301 10C6.08301 9.90166 6.1113 9.81805 6.19434 9.71289L13.2373 2.5459C13.3884 2.39677 13.6142 2.39743 13.7646 2.54785C13.9157 2.69893 13.9157 2.92607 13.7646 3.07715L13.7617 3.08008L7.23047 9.76758L7.00195 10.001L7.23145 10.2344L13.8252 16.9219L13.8271 16.9229Z" fill={COLORS.primary.base} stroke={COLORS.primary.base} strokeWidth="0.666667"/>
        </svg>
    );
};

export default React.memo(MGBWBackIcon);